import axios from 'axios';
import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { FaFileInvoiceDollar } from 'react-icons/fa6';
import Expenses from '../../../components/Expense/List/Cards/Expenses';
import ExpenseModal from '../../../components/Expense/List/Modals/Expense';
import Loading from '../../../components/Loading/Loading';
import Main from '../../../layouts/Main/Main';
import { IExpense } from '../../../types';

import { IconWrapper } from '../../../components/IconWrapper/IconWrapper';
import styles from './List.module.scss';

const List = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [showAddExpense, setShowAddExpense] = useState<boolean>(false);
  const [expenseReports, setExpenseReports] = useState<IExpense[]>([]);

  useEffect(() => {
    getExpenseReports();
  }, []);

  const handleAddExpenseModalShow = () => setShowAddExpense(true);
  const handleAddExpenseModalClose = () => {
    setShowAddExpense(false);
    getExpenseReports();
  };

  const breadcrumb = [
    { name: 'Home', path: '/' },
    { name: 'Expense Reports', path: '/expense', active: true },
  ];

  const getExpenseReports = () => {
    setLoading(true);
    axios
      .get('/api/expense')
      .then((response) => {
        if (response.status === 200) {
          setExpenseReports(response.data);
        }
      })
      .finally(() => {
        setTimeout(() => setLoading(false), 250);
      });
  };

  const actions = (
    <>
      <Button variant="primary" onClick={handleAddExpenseModalShow} size="sm">
        <IconWrapper icon={FaFileInvoiceDollar} /> Add Expense
      </Button>
    </>
  );

  return (
    <Main breadcrumb={breadcrumb} actions={actions}>
      <>
        <Container className="mt-3">
          <Loading isLoading={loading}>
            <div>
              <div className={styles.Intro}>
                <div>
                  <span className={styles.Eyebrow}>Suivi financier</span>
                  <h1 className={styles.Title}>Expense reports</h1>
                  <p className={styles.Description}>Centralisez vos frais et vos déplacements kilométriques.</p>
                </div>
                <div className={styles.Count}><strong>{expenseReports.length}</strong><span>report{expenseReports.length > 1 ? 's' : ''}</span></div>
              </div>
              <Row className={styles.List}><Col><Expenses expenses={expenseReports} /></Col></Row>
            </div>
          </Loading>
        </Container>
        <ExpenseModal show={showAddExpense} onClose={handleAddExpenseModalClose} />
      </>
    </Main>
  );
};

export default List;
